/**
 * @generated SignedSource<<ffba3dd7db10f6a94fa0e5fda532ecd0>>
 * @relayHash 77d8587ae3683b071c5af59a6dcee27c
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 77d8587ae3683b071c5af59a6dcee27c

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Config",
    "kind": "LinkedField",
    "name": "config",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "arpejLink",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "disableContractNumbersAutoGeneration",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "disableProviders",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "disableSignatureDelay",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "QConfigQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "QConfigQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": "77d8587ae3683b071c5af59a6dcee27c",
    "metadata": {},
    "name": "QConfigQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

node.hash = "d3ab31b814a3dc590074d0573c36a2f1";

export default node;
